export const alerts = {
	types: {
		info: 'info',
		error: 'error',
		success: 'success',
		warning: 'warning'
	},
	timeout: 5000
};